import { GraphStyle } from 'components/planner/types';
import { getRelativePointerPosition } from 'components/planner/utils/tools';
import Konva from 'konva';
import React, { useEffect, useMemo, useRef } from 'react';
import { Group, Rect, Text } from 'react-konva';
import { monthName } from 'utils/humanize';
import { diffDay } from 'utils/time';
import { xFromTimeStyled } from '../../utils';


function ScrollHoriz({
	start,
	initDate,
	daysTot,
	onChange,
	x,
	y,
	width,
	height,
	style
}: ScrollHorizProps) {

	// METHODs
	const factor = daysTot / style.columns
	const cursorWidth = width / factor

	const xFromTime = xFromTimeStyled(style, start)
	const calcDaysFromX = (x: number) => Math.ceil((x * factor) / style.space.x)
	const calcXFromDays = (days: number) => (days * style.space.x) / factor


	// HOOKs
	const bgRef = useRef(null)
	const cursorRef = useRef<Konva.Rect>(null)
	const timeoutIdRef = useRef(0)
	// mi serve perche' cosi' quando faccio un aggiornamento da drag non aggiorno la posizione del rettangolo (perche' lo fa gia' KONVA)
	const noUpdate = useRef(false)

	function updateCursorPos () {
		if (!cursorRef.current) return
		if (isNaN(initDate)) return
		const init = Math.max(initDate, start)
		const days = diffDay(init, start)
		const x = calcXFromDays(days)
		if (!noUpdate.current) {
			cursorRef.current.stopDrag()
			cursorRef.current.x(x)
		}
		noUpdate.current = false
	}
	// utilizzato per setare all'inizio la posizione del cursore
	useEffect(() => {
		updateCursorPos()
	}, [initDate])

	// Restituisce l'array dei mesi da visualizzare
	const months = useMemo(() => {

		noUpdate.current = false
		updateCursorPos()

		const countDate = new Date(start)
		let countX = 0
		const months = []
		while (countX < width) {
			countDate.setDate(1) //countDate.setUTCDate(1)
			countX = xFromTime(countDate.getTime()) / factor
			const monthIndex = countDate.getMonth()
			months.push({
				x: countX,
				name: monthName(monthIndex, factor > 14)
			})
			countDate.setMonth(monthIndex + 1) // countDate.setUTCMonth(monthIndex + 1)
		}
		return months
	}, [start, daysTot, width]);



	// HANDLERs

	/**Utilizzato per delimitare i limiti del drag */
	const callbackDrag = pos => {
		const posRel = bgRef.current.absolutePosition()
		pos.y = posRel.y
		if (pos.x < posRel.x) pos.x = posRel.x
		if (pos.x + cursorWidth > (posRel.x + width)) pos.x = posRel.x + width - cursorWidth
		return pos
	}

	/** se si muove il cursore calcolo i giorni della sua posizione */
	const handleDragMove = e => {
		e.cancelBubble = true
		if (timeoutIdRef.current != 0) return
		const x = e.target.x()
		const days = calcDaysFromX(x)
		timeoutIdRef.current = window.setTimeout(() => {
			onChange?.(days)
			noUpdate.current = true
			timeoutIdRef.current = 0
		}, 25)
	}

	const handleClick = e => {
		e.cancelBubble = true
		const pos = getRelativePointerPosition(e.target)
		const x = pos.x - (cursorWidth / 2)
		const days = calcDaysFromX(x)
		onChange?.(days)
		//cursorRef.current.x(x)
	}



	// RENDER

	return (<Group x={x} y={y} width={width} height={height}>
		<Rect ref={bgRef}
			onClick={handleClick}
			onTap={handleClick}
			fill={style.scroll.bg.color}
			x={0} y={0}
			width={width} height={height}
		/>
		<Rect ref={cursorRef}
			onDragMove={handleDragMove}
			draggable
			dragBoundFunc={callbackDrag}
			fill={style.scroll.cursor.color}
			x={0} y={0}
			width={cursorWidth} height={height}
		/>

		{months.map(month => (
			<Text key={month.x} listening={false}
				text={month.name}
				x={month.x}
				y={5}
				fontSize={style.scroll.label.size}
				height={style.space.y}
				fill={style.scroll.label.color}
			/>
		))}
	</Group>)
}

ScrollHoriz.CalcHeight = ({ style }: { style: GraphStyle }) => style.scroll.height

export default ScrollHoriz

type ScrollHorizProps = {
	/** data di inizio del gantt. Mi serve per mettere i mesi */
	start: number,
	/** la data iniziale! Appena si renderizza lo scroll dove deve essere posizionato? */
	initDate: number,
	/** giorni totali che deve abbracciare tutto lo scrolling */
	daysTot: number,
	/** chiamato quando si scrolla o cmq cambia lo scrolling */
	onChange: (days: number) => void,

	x: number,
	y: number,
	width: number,
	height: number,
	style: GraphStyle
}